import React, { Component } from 'react'

import Button from 'components/Button'
import { Link } from 'react-router'
import { get } from 'lodash'
import Tag from 'components/Tag'

import cn from 'classnames'
import s from './BlogPreview.scss'
import sText from 'components/Text/Text.scss'
import sLay from 'styles/modules/layout.scss'

export default class BlogPreview extends Component {
  static defaultProps = {
    article: {},
  }
  render() {
    const { horizontal, article, location } = this.props
    const fields = article && article.fields
    const exerpt = `${get(fields, 'blurb', '').substring(0, 150)}...`
    const author = get(fields, 'author.fields.name')
    const image = get(fields, 'featuredImage.fields.file.url')
    const basePath = location.pathname.split('/')[1]

    return (
      <div className={cn(s.article, { [s.horizontal]: horizontal })}>
        {image ? (
          <Link
            to={`/${basePath}/${fields.slug}`}
            className={s.image}
            style={{ backgroundImage: `url(${image})` }}
          />
        ) : (
          <div className={s.image} />
        )}
        {fields && fields.title ? (
          <div
            className={cn(
              s.content,
              sLay.flex,
              sLay['layout-column'],
              sLay['layout-align-start-start']
            )}
          >
            <div className={cn(sLay['layout-row'], s.tags)}>
              {get(fields, 'categories', []).map((tag, idx) => (
                <Tag
                  key={idx}
                  idx={tag.fields.colorIndex || 1}
                  {...(basePath === 'blog' && {
                    to: { pathname: '/blog', query: { category: tag.fields.name } },
                  })}
                >
                  {tag.fields.name}
                </Tag>
              ))}
            </div>
            <Link to={`/${basePath}/${fields.slug}`} className={cn(s.title, sText.heading3)}>
              {get(fields, 'title')}
            </Link>
            <div className={cn(s.meta)}>
              By&nbsp;
              {basePath === 'blog' ? (
                <Link className={cn(s.metaLink)} to={{ pathname: '/blog', query: { author } }}>
                  {author}
                </Link>
              ) : (
                author
              )}
            </div>
            <div className={s.descrip} dangerouslySetInnerHTML={{ __html: exerpt }} />
            <div className={sLay.flex} />
            <Button plain to={`/${basePath}/${fields.slug}`}>
              More
            </Button>
          </div>
        ) : (
          <div
            className={cn(
              s.content,
              sLay.flex,
              sLay['layout-column'],
              sLay['layout-align-start-start']
            )}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Blog/BlogPreview/BlogPreview.jsx